// extracted by mini-css-extract-plugin
export default {"Content":"CreateRevisionFullView_Content__LPS5r"};